import dayjs from 'dayjs';
import { scroller } from 'react-scroll';
import { ENUM_SCHEDULER_STATUS } from './enums/enums';

//dispatchCusEvent - кинуть пользовательское событие
export const dispatchCusEvent = (eventName, detail = {}, el = window) => {
  el.dispatchEvent(new CustomEvent(eventName, { detail: detail }));
};

// validateEmail - валидация емаил
export function validateEmail(address) {
  let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

  return reg.test(address);
}

//checkCardNumber - проверка реальная ли карта
export const checkCardNumber = (cardNumber) => {
  const chars = [];
  const len = cardNumber.length;

  // длина номера платежной карты от 13 до 19 символов
  if (len < 13 || len > 19) return false;

  // Проверьте, содержит ли номер карты только цифры
  for (let i = 0; i < len; ++i) {
    const ch = cardNumber.charAt(i);
    if (ch < '0' || ch > '9') return false;
    chars.push(parseInt(ch, 10));
  }

  // Применить алгоритм Луна (удвоить каждую вторую цифру, вычесть 9, если больше 9)
  let start = len % 2 === 0 ? 0 : 1;
  for (let i = start; i < len; i += 2) {
    let x = chars[i] * 2;
    if (x > 9) x -= 9;
    chars[i] = x;
  }

  // Вычислить сумму всех цифр
  let sum = 0;
  for (let i = 0; i < len; ++i) {
    sum += chars[i];
  }

  // проверка делится ли сумма на 10 (проверка Луна)
  return sum % 10 === 0;
};

// messageByCode - получение текста по коду
export const messageByCode = (code) => {
  if (code == 601) return 'Captcha check failed';
  if (code == 602) return 'Incorrect login or password';
  if (code == 603) return 'No access rights';
  if (code == 604) return 'User is not authorized';
  if (code == 605) return 'Invalid group id';
  if (code == 606) return 'Invalid parent group id';
  if (code == 607) return 'Invalid group name';
  if (code == 608) return 'A group with the given name already exists';
  if (code == 609) return 'The group cannot be deleted because it contains users';
  if (code == 610) return 'Group agent password not set or invalid';
  if (code == 611) return 'Cannot rename root group';
  if (code == 612) return 'There is no casino installed in the group';
  if (code == 613) return 'No games collection selected in casino';
  if (code == 614) return 'Invalid campaign id';
  if (code == 615) return 'Invalid bonus id';
  if (code == 616) return 'Invalid URL format';
  if (code == 617) return 'The bot/casino does not have a game collection specified.';
  if (code == 618) return 'The crypto gateway merchant ID is not set';
  if (code == 619) return 'The crypto gateway vendor ID is not specified.';
  if (code == 620) return 'Invalid password';
  if (code == 621) return 'Invalid password the new password is too weak';
  if (code == 622) return 'Unable to move user to group of specified type';
  if (code == 623) return 'The game does not contain all the necessary data';
  if (code == 624) return 'Invalid command format for Telegram bot';
  if (code == 625)
    return 'The login cannot be changed. For example, if the specified user was registered in the game bot.';
  if (code == 626) return 'Invalid email address';
  if (code == 627) return 'Invalid phone number';
  return 'An error occurred';
};

// запись и получение из локалсторадж
export const getLcs = (name, def) => JSON.parse(localStorage.getItem(name)) ?? def;
export const setLcs = (name, data) => localStorage.setItem(name, JSON.stringify(data));

// scrollToElement- плавная прокрутка до элемента
export const scrollToElement = (elementName) => {
  scroller.scrollTo(elementName, { duration: 800, smooth: 'easeInOutQuart' });
};

export const getNumberValue = (val) => {
  if (val >= 0) return Number(val);
  return Math.abs(val);
};

export const returnNimMaxNumber = (val, min, max) => {
  if (val < min) return +min;
  if (val > max) return +max;
  return +val;
};

export const getOnlyData = (val, time = '', format = 'YYYY-MM-DD') => {
  try {
    if (!val) return '';

    // Если это dayjs
    if (dayjs.isDayjs(val)) {
      const date = val.format(format);
      return `${date} ${time}`.trim();
    }

    // Если это обычный Date
    if (val instanceof Date) {
      const date = val.toISOString().split('T')[0];
      return `${date} ${time}`.trim();
    }

    console.log('t', time);

    return val;
  } catch (e) {
    console.error(e);
    return val;
  }
};

export const getFormatDate = (date, format = 'DD.MM.YYYY') =>
  date ? getOnlyData(dayjs(date), '', format) : '';

export function arraysEqual(arr1, arr2, checkIndex = false) {
  if (arr1.length !== arr2.length) return false;

  if (checkIndex) {
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    return true;
  }

  const set1 = new Set(arr1);
  const set2 = new Set(arr2);

  for (let id of set1) {
    if (!set2.has(id)) return false;
  }

  return true;
}

export function objEqual(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function areObjectsEqualSimple(obj1, obj2) {
  const keys = Object.keys(obj1);
  return keys.every((key) => obj1[key] === obj2[key]);
}

// Функция для проверки имени файла
export const isValidFileName = (fileName) => {
  // Разрешенные символы: a-z, A-Z, 0-9, -, _, .
  const validFileNameRegex = /^[a-zA-Z0-9\-_.\s]+$/;

  // Проверка имени файла (без пути)
  const nameWithoutPath = fileName.split('/').pop().split('\\').pop();

  return validFileNameRegex.test(nameWithoutPath);
};

export const isVideoFormat = (fileSource) => {
  const extension = fileSource.split('.').pop().toLowerCase();
  const videoExtensions = ['mp4', 'avi', 'mov', 'webm', 'mkv', 'webm'];
  return videoExtensions.includes(extension);
};

export const searchWithoutRegister = (name1, name2) =>
  name1.toLowerCase().search(name2.toLowerCase()) >= 0;

export const generateRandomString = (length = 40) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);

  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars[array[i] % chars.length];
  }
  return result;
};

export function formatNumber(num) {
  try {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  } catch (e) {
    console.log(e);
    return num;
  }
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const getReadOnlyScheduler = (status) =>
  [
    ENUM_SCHEDULER_STATUS.inactive,
    ENUM_SCHEDULER_STATUS.progress,
    ENUM_SCHEDULER_STATUS.finished
  ].includes(status);

export const goMacroTask = (cb) => setTimeout(cb, 0);

export const isSelectedMenu = (href, pathname) => {
  if (!href) return false;

  if (href.includes('?')) {
    const [hrefPathname, hrefSearch] = href.split('?');
    const currentSearch = window.location.search.substring(1);

    return hrefPathname === pathname && hrefSearch === currentSearch;
  }

  return href === pathname;
};

export const isActiveMenu = (items, path) =>
  items?.some((item) => isSelectedMenu(item.href, path) || isActiveMenu(item.children, path));

export const longYearToShort = (input) => {
  const [year, month] = input.split('/');
  const result = `${month}/${year.slice(-2)}`;
  return result;
};
